module.exports = __webpack_public_path__ + "img/coins.e2f194d7.svg";